import { gql } from '@provision/graphql-client';

export const GET_ACTIVATION_FLOW_CONFIG_QUERY = gql`
  query GetBundledActivationFlowConfig($input: GetActivationFlowConfigInput!) {
    getBundledActivationFlowConfig(input: $input) {
      id
      options {
        showFaq
        showContactSupport
        contactSupportLink
        mostPopularProductId
        productOrder
        showMonthlyPrices
        showAnnualPrices
        showSkipPriceSelection
        requireTosBeforePlans
        setupCheckoutText
        callForPricingPhone
        faqQuestions {
          question
          answer
        }
        branding {
          primaryColor
          secondaryColor
          bannerColor
          pageBlock1Color
          backgroundImageUrl
        }
        termsOfServiceUrl
        privacyPolicyUrl
      }
      features {
        membershipFeatureId
        name
        sortOrder
        defaultContent
        defaultTooltip
      }
      products {
        id
        name
        platformSlaId
        callForPricing
        activeFeatures {
          membershipFeatureId
          overrideContent
          overrideTooltip
        }
        prices {
          monthly {
            id
            amountCents
            stripePriceId
          }
          annual {
            id
            amountCents
            stripePriceId
          }
        }
      }
    }
  }
`;

export const GET_ACTIVATION_FLOW_CONFIG_BRAND_LINKS_QUERY = gql`
  query GetActivationFlowConfigBrandLinks($input: GetActivationFlowConfigInput!) {
    getBundledActivationFlowConfig(input: $input) {
      id
      options {
        termsOfServiceUrl
        privacyPolicyUrl
        contactSupportLink
      }
    }
  }
`;

export const SAVE_ACTIVATION_FLOW_CONFIG_BUNDLE_MUTATION = gql`
  mutation SaveActivationFlowConfigBundle($input: SaveActivationFlowConfigBundleInput!) {
    saveActivationFlowConfigBundle(input: $input) {
      success
    }
  }
`;

export const COPY_ACTIVATION_FLOW_CONFIG_MUTATION = gql`
  mutation CopyActivationFlowConfig($input: CopyActivationFlowConfigInput!) {
    copyActivationFlowConfig(input: $input) {
      success
    }
  }
`;

export const CREATE_INITIAL_MEMBERSHIPS_CONFIG_MUTATION = gql`
  mutation CreateInitialMembershipsConfig($partnerId: Int!) {
    createInitialMembershipsConfig(input: { partnerId: $partnerId }) {
      partnerProducts {
        id
        partnerProductId
        partnerId
        displayName
        description
        type
        platformSlaId
        stripeProductId
        isActive
        createdAt
        updatedAt
        callForPricing
      }
    }
  }
`;
